import { BehaviorSubject, Subject } from "rxjs";
import { Injectable } from "@angular/core";
import { Option } from "../model/model.class";

@Injectable()
export class Theme{
    private __data = new BehaviorSubject<any>("green");
    public themecolor= this.__data.asObservable();

    private __event = new BehaviorSubject<number>(0);
    public event= this.__event.asObservable();

    private __phone = new BehaviorSubject<boolean>(false);
    public phone= this.__phone.asObservable();

    private __lead = new BehaviorSubject<number>(-1);
    public lead= this.__lead.asObservable();

    private __newlead = new BehaviorSubject<boolean>(false);
    public newlead= this.__newlead.asObservable();
    
    private __showmenu = new BehaviorSubject<boolean>(true);
    public showmenu= this.__showmenu.asObservable();

    private __contactmenu = new BehaviorSubject<boolean>(true);
    public contactmenu= this.__contactmenu.asObservable();

    private __powermenu = new BehaviorSubject<boolean>(true);
    public powermenu = this.__powermenu.asObservable();

    private  _changelook = new BehaviorSubject<boolean>(false);
    public  changelook = this._changelook.asObservable();

    private __currentdispo = new BehaviorSubject<number>(0);
    public currentdispo = this.__currentdispo.asObservable();

    private __sipdata = new BehaviorSubject<string>(null);
    public sipjsdata= this.__sipdata.asObservable();    

    private __callerid = new BehaviorSubject<any>(null);
    public callerid= this.__callerid.asObservable();
    
    private __savesms = new BehaviorSubject<any>(null);
    public savesms = this.__savesms.asObservable();

    private __dataemail = new BehaviorSubject<Option[]>(null);
    public emailsolution= this.__dataemail.asObservable();

    private __datasms = new BehaviorSubject<Option[]>(null);
    public smsolution= this.__datasms.asObservable();

    private __datavd = new BehaviorSubject<Option[]>(null);
    public vdsolution= this.__datavd.asObservable();

    private __datasemail = new BehaviorSubject<any>(null);
    public saveemail= this.__datasemail.asObservable();

    private __datavdsms = new BehaviorSubject<any>(null);
    public savevdmsg= this.__datavdsms.asObservable();

    private __autodial = new BehaviorSubject<number>(null);
    public solautodial= this.__autodial.asObservable();

    private __startautodial = new BehaviorSubject<number>(null);
    public startautodial= this.__startautodial.asObservable();

    private __stopautodial = new BehaviorSubject<number>(null);
    public stopautodial= this.__stopautodial.asObservable();

    private __callback = new BehaviorSubject<any>(null);
    public callback= this.__callback.asObservable();

    private __callring = new BehaviorSubject<number>(null);
    public callring = this.__callring.asObservable();

    private __crmdata = new BehaviorSubject<any>(null);
    public crmdata = this.__crmdata.asObservable();

    private __getbalance = new BehaviorSubject<boolean>(false);
    public getbalance= this.__getbalance.asObservable();

    private __updatebalance = new BehaviorSubject<boolean>(false);
    public updatebalance= this.__updatebalance.asObservable();

    private __searchlead = new BehaviorSubject<string>(null);
    public searchlead = this.__searchlead.asObservable();

    private __loadlead = new BehaviorSubject<any>(null);
    public loadlead= this.__loadlead.asObservable();

    private __autoloadlead = new BehaviorSubject<any>(null);
    public autoloadlead= this.__autoloadlead.asObservable();

    private __mgloadlead = new BehaviorSubject<any>(null);
    public mgloadlead= this.__mgloadlead.asObservable();

    private __cbloadlead = new BehaviorSubject<any>(null);
    public cbloadlead= this.__cbloadlead.asObservable();

    private __currcallback = new BehaviorSubject<any>(null);
    public currcallback= this.__currcallback.asObservable();

    private __globalfilter = new BehaviorSubject<any>(null);
    public globalfilter= this.__globalfilter.asObservable();

    private __loadfilterleads = new BehaviorSubject<any>(null);
    public loadfilterleads= this.__loadfilterleads.asObservable();

    private __rotatecaller = new BehaviorSubject<any>(null);
    public rotatecaller= this.__rotatecaller.asObservable();

    private __pkgnotification = new BehaviorSubject<any>(null);
    public pkgnotification= this.__pkgnotification.asObservable();

    private __profilepic = new BehaviorSubject<any>(null);
    public profilepic= this.__profilepic.asObservable();

    private __allsmslistview = new BehaviorSubject<any>(null);
    public allsmslistview= this.__allsmslistview.asObservable();

    private __singlesmsview = new BehaviorSubject<any>(null);
    public singlesmsview= this.__singlesmsview.asObservable();

    private __showdialpad = new BehaviorSubject<boolean>(false);
    public showdialpad= this.__showdialpad.asObservable();

    private __unregistersip = new BehaviorSubject<boolean>(false);
    public unregistersip= this.__unregistersip.asObservable();

    private __savecbsms = new BehaviorSubject<any>(null);
    public savecbsms = this.__savecbsms.asObservable();

    private __datacbsemail = new BehaviorSubject<any>(null);
    public savecbemail= this.__datacbsemail.asObservable();

    private __datacbvdsms = new BehaviorSubject<any>(null);
    public savecbvdmsg= this.__datacbvdsms.asObservable();

    private __saveausms = new BehaviorSubject<any>(null);
    public saveausms = this.__saveausms.asObservable();

    private __dataausemail = new BehaviorSubject<any>(null);
    public saveauemail= this.__dataausemail.asObservable();

    private __dataauvdsms = new BehaviorSubject<any>(null);
    public saveauvdmsg= this.__dataauvdsms.asObservable();

    private __savemgsms = new BehaviorSubject<any>(null);
    public savemgsms = this.__savemgsms.asObservable();

    private __datamgsemail = new BehaviorSubject<any>(null);
    public savemgemail= this.__datamgsemail.asObservable();

    private __datamgvdsms = new BehaviorSubject<any>(null);
    public savemgvdmsg= this.__datamgvdsms.asObservable();

    private __ninjacallerid = new BehaviorSubject<any>(null);
    public ninjacallerid= this.__ninjacallerid.asObservable();

    private __personalnumber = new BehaviorSubject<string>(null);
    public personalnumber= this.__personalnumber.asObservable();

    private __savepersonalnumber = new BehaviorSubject<any>(null);
    public savepersonalnumber= this.__savepersonalnumber.asObservable();

    private __senddtmfsip = new BehaviorSubject<any>(null);
    public senddtmfsip= this.__senddtmfsip.asObservable();

    private __clienttimezone = new BehaviorSubject<any>(null);
    public clienttimezone= this.__clienttimezone.asObservable();

    private __getautodiale = new BehaviorSubject<any>(null);
    public autodialerblock = this.__getautodiale.asObservable()
    
    private __blockautodial = new BehaviorSubject<string>(null);
    public blockautodial= this.__blockautodial.asObservable();

    private __lastcall = new BehaviorSubject<number>(0);
    public lastcall= this.__lastcall.asObservable();

    private __autosvdat = new Subject()
    public AutoSvData = this.__autosvdat.asObservable()

    private _leadtype = new Subject()
    public leadtype = this._leadtype.asObservable()

    private _totalagents = new Subject()
    public totalagents = this._totalagents.asObservable()

    // private _Comments = new Subject()
    // public Comments = this._Comments.asObservable()

    public Getautosavedata(data:any)
    {
        console.log(data)
        this.__autosvdat.next(data)
    }

    public SetLastCall(v : number)
    {
        this.__lastcall.next(v);
    }

    public SetAutoDialBlock(v : string)
    {
        this.__blockautodial.next(v);
    }
    
    public SetTimezone(v : string)
    {
        this.__clienttimezone.next(v);
    }

    public SendDTMFSip(v : any)
    {
        console.log("TTT", v)
        this.__senddtmfsip.next(v);
    }

    public SaveDialPersonalNo(v : any)
    {
        this.__savepersonalnumber.next(v);
    }

    public DialPersonalNo(v : string)
    {
        this.__personalnumber.next(v);
    }

    public NinjaCallerID(v : any)
    {
        this.__ninjacallerid.next(v);
    }

    public SaveMGSms(v : any)
    {
        this.__savemgsms.next(v);
    }

    public SaveMGVdSms(v : any)
    {
        this.__datamgvdsms.next(v);
    }

    public SaveMGEmail(v : any)
    {
        this.__datamgsemail.next(v);
    }

    public SaveAUSms(v : any)
    {
        this.__saveausms.next(v);
    }

    public SaveAUVdSms(v : any)
    {
        this.__dataauvdsms.next(v);
    }

    public SaveAUEmail(v : any)
    {
        this.__dataausemail.next(v);
    }

    public changeCBSms(v : any)
    {
        this.__savecbsms.next(v);
    }

    public SaveVdCBSms(v : any)
    {
        this.__datacbvdsms.next(v);
    }

    public SaveCBEmail(v : any)
    {
        this.__datacbsemail.next(v);
    }

    public UnregisterSIP(v : boolean)
    {
        this.__unregistersip.next(v);
    }

    public showDialpad(v : boolean)
    {
        this.__showdialpad.next(v);
    }

    public SingleSMSView(v : any)
    {
        this.__singlesmsview.next(v);
    }

    public AllSMSListView(v : any)
    {
        this.__allsmslistview.next(v);
    }

    public ChangeProfilePic(v : any)
    {
        this.__profilepic.next(v);
    } 

    public CampPkgNotification(v : any)
    {
        this.__pkgnotification.next(v);
    } 

    public ChangeRotateCaller(v : any)
    {
        this.__rotatecaller.next(v);
    } 

    public LoadFilterLeads(v : any)
    {
        this.__loadfilterleads.next(v);
    } 

    public GlobalFilter(v : any)
    {
        this.__globalfilter.next(v);
    } 

    public CurrCallback(v : any)
    {
        this.__currcallback.next(v);
    }

    public CBLoadLeads(v : any)
    {
        this.__cbloadlead.next(v);
    }

    public LoadLeads(v : any)
    {
        this.__loadlead.next(v);
    }

    public AutoLoadLeads(v : any)
    {
        this.__autoloadlead.next(v);
    }

    public MgLoadLeads(v : any)
    {
        this.__mgloadlead.next(v);
    }

    public CrmDataSt(v : any)
    {
        this.__crmdata.next(v);
    }

    public CallRingSt(v : number)
    {
        this.__callring.next(v);
    }

    public CallBackLead(v : number)
    {
        this.__callback.next(v);
    }

    public StopAutodial(v : number)
    {
        this.__stopautodial.next(v);
    }

    public StartAutodial(v : number)
    {
        this.__startautodial.next(v);
    }

    public ChangeAutodial(v : number)
    {
        this.__autodial.next(v);
    }

    public SaveVdSms(v : any)
    {
        this.__datavdsms.next(v);
    }

    public SaveEmail(v : any)
    {
        this.__datasemail.next(v);
    }

    
    public emmailtmpdata(v : any[]) {    
        this.__dataemail.next(v);
    }

    public vdtmp(v : any[]) {    
         this.__datavd.next(v);
    }

    public smsdata(v : any[]) {   
        this.__datasms.next(v);
    }
 

    public ChangeCallerID(v : any) {
        this.__callerid.next(v);
    }

    public ChangeSipData(v : string) {
        this.__sipdata.next(v);
    }

    public ChangeColor(v : string) {
        this.__data.next(v);
    }

    public ChangeEvent(v : number) {
        this.__event.next(v);
    }

    public ChangePhone(v : boolean) {
        this.__phone.next(v);
    }

    public ChangeLead(v : number) {
        this.__lead.next(v);
    }

    public NewLead(v : boolean) {
        this.__newlead.next(v);
    }

    public showMenu(v : boolean) {
        this.__showmenu.next(v);
    }

    public contactMenu(v : boolean) {
        this.__contactmenu.next(v);
    }

    public powerMenu(v : boolean) {
        this.__powermenu.next(v);
    }  

    public currentDispo(v : number) {
        this.__currentdispo.next(v);
    }

    public changeLook(v : boolean) {
        this._changelook.next(v);
    }

    public changeSms(v : any)
    {
        this.__savesms.next(v);
    }
    public GetBalance(v : boolean) {
        this.__getbalance.next(v);
    }
    public UpdateBalance(v : boolean) {
        this.__updatebalance.next(v);
    }
    public SearchLead(v : string) {
        this.__searchlead.next(v);
    }  

    public SetAutoDialeState(v : string)
    {
        console.log(v)
        this.__getautodiale.next(v)
    }
    public Totalagents(v : string)
    {
        
        this._totalagents.next(v)
    }
    // public updatecomment(v : any)
    // {
        
    //     this._Comments.next(v)
    // }

    public leadsfilter(v:string){
        this._leadtype.next(v);
    }
    constructor(){

    }
}